import { render, staticRenderFns } from "./VCountedTabs.vue?vue&type=template&id=71e72a8a&"
import script from "./VCountedTabs.vue?vue&type=script&lang=ts&"
export * from "./VCountedTabs.vue?vue&type=script&lang=ts&"
import style0 from "./VCountedTabs.vue?vue&type=style&index=0&id=71e72a8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports